import Hunt from 'huntjs';

export const InView = () => {
  const els = document.querySelectorAll('.-detect-in-viewport');
  new Hunt(els, {
    enter: (el) => {
      el.classList.add('-in-viewport');
    },
  });
};